import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-mall-category',
    templateUrl: './common-mall-category.component.html',
    styleUrls: ['./common-mall-category.component.scss'],
    standalone: false
})
export class CommonMallCategoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
